var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgScratch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1440,
    height: 960
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 470,
    height: 960
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 420,
    height: 110,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.3-Sequences-pre-made",
    transform: "translate(-55.000000, -124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#DFE2E5",
    x: -0.5,
    y: -0.5,
    width: 1441,
    height: 961
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#DFE2E5",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "info-copy",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask2",
    stroke: "#DFE2E5",
    strokeWidth: 1,
    fill: "#F7F8FA",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-blueprint",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1890FF",
    fillRule: "nonzero",
    points: "0 0 40.2777778 0 40.2777778 45.8333333 0 45.8333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55555556,1.38888889 L6.94444444,1.38888889 L6.94444444,44.4444444 L5.55555556,44.4444444 L5.55555556,1.38888889 Z M11.1111111,1.38888889 L12.5,1.38888889 L12.5,44.4444444 L11.1111111,44.4444444 L11.1111111,1.38888889 Z M16.6666667,1.38888889 L18.0555556,1.38888889 L18.0555556,44.4444444 L16.6666667,44.4444444 L16.6666667,1.38888889 Z M22.2222222,1.38888889 L23.6111111,1.38888889 L23.6111111,44.4444444 L22.2222222,44.4444444 L22.2222222,1.38888889 Z M27.7777778,1.38888889 L29.1666667,1.38888889 L29.1666667,44.4444444 L27.7777778,44.4444444 L27.7777778,1.38888889 Z M33.3333333,1.38888889 L34.7222222,1.38888889 L34.7222222,44.4444444 L33.3333333,44.4444444 L33.3333333,1.38888889 Z",
    id: "Shape",
    fill: "#88AFEA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38888889,5.55555556 L38.8888889,5.55555556 L38.8888889,6.94444444 L1.38888889,6.94444444 L1.38888889,5.55555556 Z M1.38888889,11.1111111 L38.8888889,11.1111111 L38.8888889,12.5 L1.38888889,12.5 L1.38888889,11.1111111 Z M1.38888889,16.6666667 L38.8888889,16.6666667 L38.8888889,18.0555556 L1.38888889,18.0555556 L1.38888889,16.6666667 Z M1.38888889,22.2222222 L38.8888889,22.2222222 L38.8888889,23.6111111 L1.38888889,23.6111111 L1.38888889,22.2222222 Z M1.38888889,27.7777778 L38.8888889,27.7777778 L38.8888889,29.1666667 L1.38888889,29.1666667 L1.38888889,27.7777778 Z M1.38888889,33.3333333 L38.8888889,33.3333333 L38.8888889,34.7222222 L1.38888889,34.7222222 L1.38888889,33.3333333 Z M1.38888889,38.8888889 L38.8888889,38.8888889 L38.8888889,40.2777778 L1.38888889,40.2777778 L1.38888889,38.8888889 Z",
    id: "Shape",
    fill: "#88AFEA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(9.722222, 11.111111)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1565C0",
    fillRule: "nonzero",
    points: "30.5555556 34.7222222 30.5555556 0.238888889 29.9805556 0.813888889 0.238888889 30.5555556 4.40555556 34.7222222"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1565C0",
    fillRule: "nonzero",
    points: "30.5555556 34.7222222 30.5555556 20.8333333 16.6666667 34.7222222 20.5944444 34.7222222"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFA000",
    fillRule: "nonzero",
    transform: "translate(31.943953, 31.943953) rotate(-45.001000) translate(-31.943953, -31.943953) ",
    points: "12.3022867 26.0515923 51.5856201 26.0515923 51.5856201 37.8363145 12.3022867 37.8363145"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(16.666667, 15.277778)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9E6400",
    fillRule: "nonzero",
    transform: "translate(22.787009, 3.341176) rotate(45.001000) translate(-22.787009, -3.341176) ",
    points: "21.0071479 1.95228672 24.5668701 1.95228672 24.5668701 4.7300645 21.0071479 4.7300645"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9E6400",
    fillRule: "nonzero",
    transform: "translate(18.966176, 9.243953) rotate(134.999000) translate(-18.966176, -9.243953) ",
    points: "17.5772867 5.99048118 20.3550645 5.99048118 20.3550645 12.4974256 17.5772867 12.4974256"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9E6400",
    fillRule: "nonzero",
    transform: "translate(9.243953, 18.966176) rotate(134.999000) translate(-9.243953, -18.966176) ",
    points: "7.8550645 15.7127034 10.6328423 15.7127034 10.6328423 22.2196479 7.8550645 22.2196479"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9E6400",
    fillRule: "nonzero",
    transform: "translate(3.341176, 22.785620) rotate(134.999000) translate(-3.341176, -22.785620) ",
    points: "1.95228672 21.005759 4.7300645 21.005759 4.7300645 24.5654812 1.95228672 24.5654812"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9E6400",
    fillRule: "nonzero",
    transform: "translate(13.063398, 13.063398) rotate(134.999000) translate(-13.063398, -13.063398) ",
    points: "11.6745089 11.2835367 14.4522867 11.2835367 14.4522867 14.843259 11.6745089 14.843259"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.925,39.7027778 L11.1111111,40.5166667 L11.1111111,42.8166667 L11.925,43.6305556 L12.5,44.2055556 L12.5,40.2777778 L15.2777778,40.2777778 L16.6666667,38.8888889 L12.7388889,38.8888889 L11.925,39.7027778 Z M27.7777778,44.4444444 L29.1666667,44.4444444 L29.1666667,43.0555556 L27.7777778,44.4444444 Z M38.8888889,34.7222222 L38.8888889,33.3333333 L37.5,34.7222222 L38.8888889,34.7222222 Z M34.7222222,44.4444444 L34.7222222,40.2777778 L38.8888889,40.2777778 L38.8888889,38.8888889 L34.7222222,38.8888889 L34.7222222,37.5 L31.9444444,40.2777778 L33.3333333,40.2777778 L33.3333333,44.4444444 L34.7222222,44.4444444 Z M16.6666667,34.9611111 L16.6666667,38.8888889 L18.0555556,37.5 L18.0555556,34.7222222 L20.8333333,34.7222222 L22.2222222,33.3333333 L18.2944444,33.3333333 L16.6666667,34.9611111 Z M27.7777778,23.85 L27.7777778,27.7777778 L29.1666667,26.3888889 L29.1666667,23.6111111 L31.9444444,23.6111111 L33.3333333,22.2222222 L29.4055556,22.2222222 L27.7777778,23.85 Z M22.2222222,29.4055556 L22.2222222,33.3333333 L23.6111111,31.9444444 L23.6111111,29.1666667 L26.3888889,29.1666667 L27.7777778,27.7777778 L23.85,27.7777778 L22.2222222,29.4055556 Z M33.3333333,18.2944444 L33.3333333,22.2222222 L34.7222222,20.8333333 L34.7222222,18.0555556 L37.5,18.0555556 L38.8888889,16.6666667 L34.9611111,16.6666667 L33.3333333,18.2944444 Z",
    id: "Shape",
    fill: "#1976D2",
    fillRule: "nonzero"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScratch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/scratch.67c59649.svg";
export { ForwardRef as ReactComponent };